<template lang="html">

  <div class="license">   
    <p>J'ai choisi la licence MIT parce que selon moi c'est la meilleur option soit de rendre mon code propriétaire ou, s'il est open source. La licence MIT est un excellent choix car elle me permet de partager mon code sous une licence copyleft. C'est une license de facile utilisation pour les entreprises et open source tout en permettant la monétisation.</p>
    <p>Je l'ai choisi aussi parce que l'avis de droit d'auteur doit rester intact. Cela signifie que mon nom et les dates du droit d'auteur original doivent faire partie du fichier de licence, puis vous ajoutez votre propre nom et vos dates à côté ou en dessous de l'avis d'origine.</p>
    <p>Une autre raison pour ce choix c'est que avec la licence MIT l’auteur original ne peut pas être tenu responsable. Et les changements ou versioning sont acceptables tant que l'auteur original obtient un crédit et que son nom reste sur la licence.</p>
    <hr />
    <p>MIT License</p>
    <p>Copyright (c) 2021 Eric Martins</p>
    <p>Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:</p>
    <p>The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.</p>
    <p>THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.</p>
  </div>
</template>

<script lang="js">



   export default {
       data() {
           return {
           };
       },
       
   }

</script>

<style scoped >
  .license {
    text-align: left;
    width: 50vw;
    margin-left: 25vw;
    margin-top: 5vh;
    margin-bottom: 5vh
  }
</style>
